if ($(".js-main-reviews").length) {
    const mainReviewsSlider = new Swiper(".js-main-reviews", {
        slidesPerView: "auto",
        spaceBetween: 1,
        navigation: {
            nextEl: ".js-main-reviews-next",
            prevEl: ".js-main-reviews-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 49,
            },
            1140: {
                slidesPerView: 3,
                spaceBetween: 49,
            },
        },
    });
}